import { useState } from 'react'
import { Outlet } from 'react-router-dom'
import Sidebar from './Sidebar'
import Header from './Header'

const Layout = () => {
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(true)

  return (
    <div className="flex h-screen overflow-hidden" style={{ maxWidth: '100vw' }}>
      <Sidebar isCollapsed={isSidebarCollapsed} />

      <div className="flex flex-1 flex-col overflow-hidden min-w-0">
        <Header onToggleSidebar={() => setIsSidebarCollapsed((current) => !current)} />
        <main className="flex-1 overflow-y-auto overflow-x-hidden px-4 pb-4 pt-2 md:px-6 md:pb-6">
          <div className="flex min-h-full w-full">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  )
}

export default Layout
